import script from "./CustomBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CustomBadge.vue?vue&type=style&index=0&id=43d3cfa8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d3cfa8"]])

export default __exports__